import { aboutData } from '@/mocks/homeData';

const aboutImage = 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20drama%20and%20movie%20thumbnails%20on%20a%20large%20screen%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20setting%2C%20minimalist%20design%2C%20soft%20golden%20and%20cream%20tones%2C%20cinematic%20atmosphere%2C%20high%20quality%20product%20photography&width=700&height=500&seq=about-section&orientation=landscape';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="rounded-2xl overflow-hidden">
              <img
                src={aboutImage}
                alt="麻花视频平台介绍 - 高清电视剧在线观看体验"
                className="w-full h-auto object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {aboutData.title}
            </h2>
            <div className="w-12 h-1 bg-primary-500 rounded-full mb-6"></div>
            {aboutData.content.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                {p}
              </p>
            ))}
            <div className="flex flex-wrap gap-3 mt-6">
              {['正版授权', '每日更新', 'CDN加速', '全设备支持'].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 rounded-full bg-background-200 text-foreground-700 text-sm whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}